import { MEDIA_LIST_FOLDER } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case MEDIA_LIST_FOLDER.LOAD:
      return {
        ...state,
        loading: true,
      };
    case MEDIA_LIST_FOLDER.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case MEDIA_LIST_FOLDER.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
